import PropTypes from 'prop-types'

import CardCertificationIconListItem from './certification-icon-list-item'
import {BASE_CLASS} from './config'

const CardCertificationContentList = ({contentList = []}) => {
  return (
    <ul className={`${BASE_CLASS}-serviceContentList`}>
      {contentList.map(({iconUrl, title}, index) => (
        <CardCertificationIconListItem iconUrl={iconUrl} key={index} title={title} />
      ))}
    </ul>
  )
}

CardCertificationContentList.displayName = 'CardCertificationContentList'
CardCertificationContentList.propTypes = {
  contentList: PropTypes.arrayOf(
    PropTypes.shape({
      iconUrl: PropTypes.string,
      title: PropTypes.string
    })
  )
}

export default CardCertificationContentList
